function meta(key) {
  const tags = document.getElementsByTagName("META");
  let content = "";

  for (let i = 0; i < tags.length; i++) {
    if (tags[i].name === key) {
      content = tags[i].content;
    }
  }

  return content;
}

function request(method, url, body, headers = {}) {
  return fetch(url, {
    method,
    headers: new Headers({
      Accept: "application/json",
      ...headers,
    }),
    credentials: "same-origin",
    body,
  })
    .then(response => {
      switch (response.status) {
        case 401:
          throw 401;
        case 500:
          throw 500;
      }

      return response.json();
    })
    .then(json => {
      if (json.errors) {
        throw json.errors;
      }

      return json;
    })
    .catch(errors => {
      const notAuthorized = { errors: ["Not logged in"] };

      switch (errors) {
        case 401:
          window.location = "/login";
          throw notAuthorized;
        default:
          throw errors;
      }
    });
}

function csrfRequest(url, body, headers, method) {
  const authToken = meta("csrf-token");

  return request(method, url, body, {
    "X-CSRF-TOKEN": authToken,
    ...headers,
  });
}

function get(url, headers) {
  return request("GET", url, null, headers);
}

function patch(url, body, headers) {
  return csrfRequest(url, body, headers, "PATCH");
}

function patchWithJSON(url, body) {
  return patch(url, JSON.stringify(body), {
    "Content-Type": "application/json",
  });
}

function post(url, body, headers) {
  return csrfRequest(url, body, headers, "POST");
}

function postWithJSON(url, body) {
  return post(url, JSON.stringify(body), {
    "Content-Type": "application/json",
  });
}

export { get, meta, patch, patchWithJSON, post, postWithJSON };
